function firstNonEmptyString(...candidates) {
  const match = candidates.find(
    (value) => typeof value === "string" && value.trim().length > 0
  );
  return match ? match.trim() : null;
}

function isPopulatedObject(value) {
  return Boolean(value) && typeof value === "object";
}

export function getArtistDisplayName(artist) {
  if (!artist) {
    return null;
  }

  if (typeof artist === "string") {
    return firstNonEmptyString(artist);
  }

  return firstNonEmptyString(
    artist.user_name,
    artist.user_artist_name,
    artist.artist_name,
    artist.name,
    artist.full_name,
    artist.user_username,
    artist.gallery_artist?.artist_name
  );
}

export function getArtworkArtistDisplayName(artworkData) {
  const artworkAbout = artworkData?.artwork_about ?? {};

  return (
    firstNonEmptyString(
      artworkAbout?.artwork_artist_name,
      artworkAbout?.artwork_artist_full_name,
      artworkAbout?.artist_name
    ) ||
    getArtistDisplayName(artworkAbout?.artwork_artist) ||
    getArtistDisplayName(artworkAbout?.artwork_gallery_artist) ||
    "-"
  );
}

export function getArtworkArtistCatalogueData(artworkData) {
  const artworkAbout = artworkData?.artwork_about ?? {};
  const galleryArtist = artworkAbout?.artwork_gallery_artist;

  if (isPopulatedObject(galleryArtist)) {
    return galleryArtist;
  }

  const claimedGalleryArtist = artworkAbout?.artwork_artist?.gallery_artist;
  if (isPopulatedObject(claimedGalleryArtist)) {
    return claimedGalleryArtist;
  }

  return null;
}

export function getArtworkArtistSecondaryLine(artworkData) {
  const catalogueData = getArtworkArtistCatalogueData(artworkData);
  if (!catalogueData) {
    return null;
  }

  const nationality = firstNonEmptyString(catalogueData.artist_nationality);
  const birth = firstNonEmptyString(catalogueData.artist_birth);
  const death = firstNonEmptyString(catalogueData.artist_death);
  const lead = [nationality, birth].filter(Boolean).join(", ");

  if (!lead) {
    return death ? `-${death}` : null;
  }

  return death ? `${lead}-${death}` : lead;
}
